import PropTypes from 'prop-types'

export const shapeWithIdOfString         = PropTypes.shape({Id: PropTypes.string.isRequired});
export const shapeWithIdOfAny            = PropTypes.shape({Id: PropTypes.any.isRequired});
export const arrayOfShapesWithIdOfString = PropTypes.arrayOf(shapeWithIdOfString);
export const arrayOfShapesWithIdOfAny    = PropTypes.arrayOf(shapeWithIdOfAny);
